<template>
  <subscription-form></subscription-form>
</template>

<script>
  import SubscriptionForm from "../../components/SubscriptionForm/SubscriptionForm";

  export default {
    components: {
      SubscriptionForm
    },
  }

</script>



// WEBPACK FOOTER //
// Subscription.vue?f45979e2